// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"_7wngr","rc-tabs-bar":"kwGcS","rc-tabs-tab":"wTG0l","rc-tabs-tab-active":"B50hT","terms":"MCcOf","orderHistory-navigation":"R+XsH","fieldItem":"VeEiV"};